export const TAG = 'CashBalanceWidget';
